import React from "react";
import PropTypes from "prop-types";
import "./TaggedImageGallery.css";

const TaggedImageGallery = ({ images, onImageClick }) => {
  return (
    <div className="gallery grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
      {images.map((image, index) => (
        <div
          className="gallery-item relative cursor-pointer overflow-hidden rounded-lg shadow-md"
          key={index}
          onClick={() => onImageClick && onImageClick(image)}
        >
          {/* Imagen */}
          <img
            src={image.src}
            alt={`Gallery item ${index + 1}`}
            className="gallery-image h-40 w-full object-cover transition-transform duration-300 hover:scale-105"
          />
          {/* Indicador de costo */}
          {/* <div className="absolute bottom-2 left-2 rounded bg-gray-900 bg-opacity-75 px-2 py-1 text-xs text-white">
            {image.isPublica || image.costo === 0
              ? "Gratis"
              : `Requiere Donativo $${image.costo.toFixed(2)}`}
          </div> */}
          {/* Contenedor de etiquetas */}
          <div className="tag-container absolute left-2 top-2 flex flex-wrap gap-1">
            {image.etiquetas.map((tag, tagIndex) => (
              <span
                className="tag rounded bg-blue-500 px-2 py-1 text-xs text-white"
                key={tagIndex}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

TaggedImageGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
      etiquetas: PropTypes.arrayOf(PropTypes.string),
      isPublica: PropTypes.bool.isRequired,
      costo: PropTypes.number.isRequired,
    }),
  ).isRequired,
  onImageClick: PropTypes.func,
};

export default TaggedImageGallery;
